import { Box, type SxProps } from '@mui/material';
import { type PropsWithChildren } from 'react';

type FormCardProps = PropsWithChildren<{ sx?: SxProps }>;

export const FormCard = ({ sx, children }: FormCardProps) => {
  return (
    <Box
      sx={{
        backgroundColor: 'background.paperCard',
        borderRadius: 1,
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
